<script>
import { mapGetters } from 'vuex'
import { pick } from 'lodash-es'

export default {
    computed: {
        ...mapGetters('cart', [
            'count'
        ])
    },

    methods: {
        toggle() {
            this.$bus.$emit('cart-widget-toggled')
        }
    },

    render() { 
        return this.$scopedSlots.default(
            pick(this, 'count', 'toggle')
        )
    }
}
</script>

